import * as React from 'react';
import { EInputType, GeoSuggest, TSuggestionCustomInputProps } from '@cian/geosuggest-widget';
import * as styles from './styles.css';
import { IGeoSuggestionFieldProps } from './types';
import { FormInput } from '../FormInput';
import { IconSearch16, InputAdornment } from '@cian/ui-kit';

export const GeoSuggestionField: React.FC<React.PropsWithChildren<IGeoSuggestionFieldProps>> = props => {
  const renderInput = React.useCallback(
    ({ forwardRef, onChange, ...suggestProps }: TSuggestionCustomInputProps) => (
      <FormInput
        {...suggestProps}
        inputRef={forwardRef}
        name={props.inputName}
        onChange={event => onChange(event.target.value)}
        leftAdornment={
          <InputAdornment>
            <IconSearch16 color="black_100" />
          </InputAdornment>
        }
        invalid={!!props.errorMessage}
        errorMessage={props.errorMessage}
        autoFocus
      />
    ),
    [props.errorMessage, props.inputName],
  );

  const geoSuggestProps = {
    value: props.value,
    selectedValue: props.value,
    error: props.suggestError,
    suggestData: props.suggestData,
    onItemClick: props.onItemClick,
    onValueChange: props.onValueChange,
    inputStyle: [props.errorMessage ? styles['suggest-error'] : {}],
    placeholder: props.placeholder,
    isLoading: props.isLoading,
    onBlur: props.onBlur,
  };

  return <GeoSuggest {...geoSuggestProps} renderInput={renderInput} inputType={EInputType.custom} />;
};
